// extracted by mini-css-extract-plugin
export default {"root":"IconFavorites_root__gThGe"};